export default "__VITE_ASSET__ClNxZZU7__"